/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/familyMembersMappers";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a FamilyMembers. */
export class FamilyMembers {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a FamilyMembers.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Calls Graph Family APIs to return family members.
   * @summary Retrieves members of the current user's family.
   * @param [options] The optional parameters
   * @returns Promise<Models.FamilyMembersGetFamilyMembersResponse>
   */
  getFamilyMembers(options?: coreHttp.RequestOptionsBase): Promise<Models.FamilyMembersGetFamilyMembersResponse>;
  /**
   * @param callback The callback
   */
  getFamilyMembers(callback: coreHttp.ServiceCallback<Models.FamilyMember[]>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getFamilyMembers(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.FamilyMember[]>): void;
  getFamilyMembers(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.FamilyMember[]>, callback?: coreHttp.ServiceCallback<Models.FamilyMember[]>): Promise<Models.FamilyMembersGetFamilyMembersResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getFamilyMembersOperationSpec,
      callback) as Promise<Models.FamilyMembersGetFamilyMembersResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const getFamilyMembersOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/family",
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "FamilyMember"
            }
          }
        }
      }
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
